const listeners = [];
export const listen = listener => {
  listeners.push(listener);
};
export const emit = config => {
  listeners.forEach(listener => {
    void listener(config);
  });
};